import { push } from 'react-router-redux';

import { joinPath } from '@eb/path-utils';
import { trackEventFromState } from '@eb/site-analytics';

import {
    BASE_URL,
    OVERVIEW_PAGE,
    PACKAGE_COMPARISON_PATH,
    PACKAGE_ONE_PATH,
    PACKAGE_THREE_PATH,
    PACKAGE_TWO_PATH,
    PRICING_PATH,
} from '../constants/main';
import {
    COMPARE_PACKAGES_VIEW_ACTION,
    ESSENTIALS_VIEW_ACTION,
    ORG_MARKETING_CATEGORY,
    PREMIUM_VIEW_ACTION,
    PRICING_VIEW_ACTION,
    PROFESSIONAL_VIEW_ACTION,
} from '../constants/analytics';
import { getWindowObject } from '@eb/feature-detection';

const _logMunchkin = (path) => {
    const MunchkinScript = getWindowObject('Munchkin');

    // Munchkin script must be included in template for this to work
    // eslint-disable-next-line no-undef
    if (MunchkinScript && Munchkin.munchkinFunction) {
        // eslint-disable-next-line no-undef
        Munchkin.munchkinFunction('clickLink', path);
    }
};

export const SET_SELECTED_PACKAGE_ACTION = 'setSelectedPackage';
export const setSelectedPackage = (selectedPackage) => ({
    type: SET_SELECTED_PACKAGE_ACTION,
    payload: selectedPackage,
});

export const CLEAR_SELECTED_PACKAGE_ACTION = 'clearSelectedPackage';
export const clearSelectedPackage = () => ({
    type: CLEAR_SELECTED_PACKAGE_ACTION,
});

export const goToPricing = (gaAction, selectedPackage = '') => (
    dispatch,
    getState,
) => {
    const state = getState();

    if (gaAction) {
        const gaProperties = {
            action: gaAction,
            category: ORG_MARKETING_CATEGORY,
        };

        trackEventFromState(state, gaProperties);
    }

    _logMunchkin({ href: joinPath(BASE_URL, PRICING_PATH) });

    const properties = {
        action: PRICING_VIEW_ACTION,
        category: ORG_MARKETING_CATEGORY,
    };

    trackEventFromState(state, properties);
    if (selectedPackage) {
        dispatch(setSelectedPackage(selectedPackage));
    }
    dispatch(push(joinPath(BASE_URL, PRICING_PATH)));
};

export const goToPackageComparison = (
    selectedPackage = '',
    gaAction,
    label,
) => (dispatch, getState) => {
    const state = getState();

    if (gaAction) {
        trackEventFromState(state, {
            action: gaAction,
            category: ORG_MARKETING_CATEGORY,
            label,
        });
    }

    _logMunchkin({ href: joinPath(BASE_URL, PACKAGE_COMPARISON_PATH) });

    trackEventFromState(state, {
        action: COMPARE_PACKAGES_VIEW_ACTION,
        category: ORG_MARKETING_CATEGORY,
    });

    dispatch(setSelectedPackage(selectedPackage));
    dispatch(push(joinPath(BASE_URL, PACKAGE_COMPARISON_PATH)));
};

export const goToOverviewPage = () => (dispatch) => {
    _logMunchkin({ href: joinPath(BASE_URL, OVERVIEW_PAGE) });

    dispatch(push(joinPath(BASE_URL, OVERVIEW_PAGE)));
};

export const goToPackageOne = (gaAction, label) => (dispatch, getState) => {
    const state = getState();

    if (gaAction) {
        trackEventFromState(state, {
            action: gaAction,
            category: ORG_MARKETING_CATEGORY,
            label,
        });
    }

    _logMunchkin({ href: joinPath(BASE_URL, PACKAGE_ONE_PATH) });

    trackEventFromState(state, {
        action: ESSENTIALS_VIEW_ACTION,
        category: ORG_MARKETING_CATEGORY,
    });

    dispatch(push(joinPath(BASE_URL, PACKAGE_ONE_PATH)));
};

export const goToPackageTwo = (gaAction, label) => (dispatch, getState) => {
    const state = getState();

    if (gaAction) {
        trackEventFromState(state, {
            action: gaAction,
            category: ORG_MARKETING_CATEGORY,
            label,
        });
    }

    _logMunchkin({ href: joinPath(BASE_URL, PACKAGE_TWO_PATH) });

    trackEventFromState(state, {
        action: PROFESSIONAL_VIEW_ACTION,
        category: ORG_MARKETING_CATEGORY,
    });

    dispatch(push(joinPath(BASE_URL, PACKAGE_TWO_PATH)));
};

export const goToPackageThree = (gaAction, label) => (dispatch, getState) => {
    const state = getState();

    if (gaAction) {
        trackEventFromState(state, {
            action: gaAction,
            category: ORG_MARKETING_CATEGORY,
            label,
        });
    }

    _logMunchkin({ href: joinPath(BASE_URL, PACKAGE_THREE_PATH) });

    trackEventFromState(state, {
        action: PREMIUM_VIEW_ACTION,
        category: ORG_MARKETING_CATEGORY,
    });

    dispatch(push(joinPath(BASE_URL, PACKAGE_THREE_PATH)));
};
